export default [
  'Modern Design',
  'Contemporary',
  'Ceramic',
  'Street',
  'Wood',
  'Pop',
  'Stone',
  'Abstract',
  'Tableware',
  'Painting',
  'Asian',
  'Photography',
  'Japan',
  'Sculpture',
  'Furniture',
  'Prints',
  'Vessel',
  'Work on Paper',
  'Open Form',
  'Design',
  'Focus on Materials',
  'Drawing',
  'Bronze',
  'Installation',
  'Metal',
  'Film/Video',
  'Jewelry',
  'Mixed Media',
  'Performance Art',
  'Reproduction',
  'NFT',
].map(item => {
  return {
    name: item,
    slug: encodeURIComponent(item) 
  }
})